module.exports = __webpack_public_path__ + "static/media/booker.f08a99dd.jpg";